"use strict";

import angular from "angular";

angular.module("nucont.logout").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.logout", {
        url: "logout",
        onEnter: ["JWTService", (JWTService) => {
            JWTService.signout();
        }]
    });
}
